module.exports = __webpack_public_path__ + "static/media/4.3778a70d.png";